import { useEffect } from "react";
import { useLocation, useParams, matchPath } from "react-router-dom";
import api from "@/lib/api";

// Deduplicate fast double-fires (e.g. React StrictMode) by only sending one hit per
// unique (path + kind + ref_id) within a short window.
const recent = new Map();
const WINDOW_MS = 1000;

function send(payload) {
  const key = `${payload.path}|${payload.kind || ""}|${payload.ref_id || ""}`;
  const now = Date.now();
  const last = recent.get(key) || 0;
  if (now - last < WINDOW_MS) return;
  recent.set(key, now);
  // Fire and forget — never block the UI on analytics
  api.post("/track", payload).catch(() => { /* silently ignore */ });
}

// Auto pageview tracker for the router. Attach once at App level.
export default function usePageTracker() {
  const location = useLocation();
  useEffect(() => {
    // Determine kind + ref_id from path
    const path = location.pathname;
    let kind = "other";
    let refId = null;
    if (path === "/") kind = "board";
    else if (path === "/blog") kind = "blog_list";
    else {
      const opp = matchPath("/opportunity/:id", path);
      const post = matchPath("/blog/:id", path);
      if (opp) { kind = "opportunity"; refId = opp.params.id; }
      else if (post) { kind = "blog"; refId = post.params.id; }
    }
    send({ path, kind, ref_id: refId, ref: document.referrer || null });
  }, [location.pathname]);
}

export function useOpportunityView(id) {
  return useEffect(() => {
    if (id) send({ path: `/opportunity/${id}`, kind: "opportunity", ref_id: id, ref: document.referrer || null });
  }, [id]);
}
